goog.provide("shadow.js.shim.module$src$svg$chevron$chevron_down_svg");
goog.provide("module$shadow_js_shim_module$src$svg$chevron$chevron_down_svg");
shadow.js.shim.module$src$svg$chevron$chevron_down_svg = shadow.js.nativeProvides["src/svg/chevron/chevron-down.svg"] = shadow$bridge("src/svg/chevron/chevron-down.svg");
module$shadow_js_shim_module$src$svg$chevron$chevron_down_svg.default = shadow.js.shim.module$src$svg$chevron$chevron_down_svg;
